export default "__VITE_ASSET__jOe1IIQ3__"